import config from '../core/config'
import cookies from '../helpers/cookie'
import services from '../core/service'
import { Promise } from "core-js";

const SaveMeteringCookie = () => {
  // Load user by 'token' cookie
  // Get the entitlements fetching api authorization
  // Set the cookie of entitlements, if the api is down, set 'ServiceDown' cookie
  // returns a promise alwalys resolved
  // reasons:
  const NOT_LOGGUED_IN = 'NOT_LOGGUED_IN';
  const SUCESS = 'SUCESS';
  const ERROR = 'ERROR';

  cookies.erase(config.authCookie);
  cookies.erase(config.authDownCookie);
  const token = cookies.read(config.tokenCookie);

  if (!token)
    return Promise.resolve(NOT_LOGGUED_IN);

  return services.fetchGet(config.api.authorization + '/Authorize/user', { 'X-Token': token || '' })
    .then(response => {
      switch (response.status) {
        case 200:
          return response.text()
            .then(data => {
              if (data) {
                cookies.write(config.authCookie, data);
              }
              console.log('sucess')
              return Promise.resolve(SUCESS);
            })
            .catch(err => Promise.resolve(ERROR))
          break;
        case 500:
          console.log('serviceDown')
          cookies.writeExpritation(config.authDownCookie, true, config.authDownCookieExpiration);
          return Promise.resolve(ERROR)
          break;
        default:
          return Promise.resolve(NOT_LOGGUED_IN)
          break;
      }
  })
  .catch (res => {
      console.log('serviceDown', res);
      cookies.writeExpritation(config.authDownCookie, true, config.authDownCookieExpiration);
      return Promise.resolve(ERROR)
  })
}

export default SaveMeteringCookie;




// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/controllers/meteringAuth.js